<div class="modal-header">
  <h4 class="modal-title">Recherche de références</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="!showSelectedResults">
  <h5 class="p-3">Références</h5>

  <div class="my-3 p-3 bg-white rounded shadow-sm">
    <div class="input-group mb-4">
      <input 
        type="text" 
        class="form-control" 
        placeholder="Recherche" 
        [(ngModel)]="searchRequest.query" 
        (keyup)="onSearchKeyup($event)"
        [attr.disabled]="loading ? 'DISABLED' : null"
      />

      <author-search-criteria class="input-group-append" [loading]="loading"></author-search-criteria>
      
      <publisher-search-criteria class="input-group-append" [loading]="loading"></publisher-search-criteria>
      
      <genre-search-criteria class="input-group-append" [loading]="loading"></genre-search-criteria>

      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" [attr.disabled]="loading ? 'DISABLED' : null" (click)="querySearch()">
          <i *ngIf="!searchInProgress" class="bi bi-search"></i>
          <span *ngIf="searchInProgress" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
      </div>
    </div>

    <div class="btn-toolbar">
      <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('author').length > 0">
        <div class="input-group-prepend">
          <div class="btn btn-secondary btn-sm">{{ displayAuthorFilter() }}</div>
        </div>
        <div class="input-group-append">
          <button class="btn btn-secondary btn-sm" type="button" (click)="clearAuthors()" >X</button>
        </div>
      </div>

      <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('genre').length > 0">
        <div class="input-group-prepend">
          <div class="btn btn-secondary btn-sm">{{ displayGenreFilterFr() }}</div>
        </div>
        <div class="input-group-append">
          <button class="btn btn-secondary btn-sm" type="button" (click)="clearGenres()" >X</button>
        </div>
      </div>

      <div class="input-group pb-2" *ngIf="searchRequest.getValues('publisher').length > 0">
        <div class="input-group-prepend">
          <div class="btn btn-secondary btn-sm">{{ displayPublisherFilter() }}</div>
        </div>
        <div class="input-group-append">
          <button class="btn btn-secondary btn-sm" type="button" (click)="clearPublishers()" >X</button>
        </div>
      </div>
    </div>

    <div class="border-bottom"></div>

    <table class="table table-sm mt-3" *ngIf="results">
      <tr *ngFor="let reference of results.content">
        <td>
          <button class="btn btn-sm btn-primary" (click)="toggleSelected(reference.isbn, reference)" *ngIf="isSelected(reference.isbn)">
            <span class="bi bi-check2-square "></span>
          </button>
          <button class="btn btn-sm" (click)="toggleSelected(reference.isbn, reference)" *ngIf="!isSelected(reference.isbn)">
            <span class="bi bi-square"></span>
          </button>
        </td>
        <td><reference-image [reference]="reference"></reference-image></td>
        <td>{{ reference.isbn }}</td>
        <td>{{ reference.title }}</td>
        <td>{{ reference.authors }}</td>
        <td>
          <span *ngIf="reference.supplierReferences.length > 0">{{ reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }} $</span>
        </td>
        <td>
          <a class="ml-2" [routerLink]="['/inventory/reference', reference.isbn]" target="_blank"><i class="bi bi-card-heading"></i></a>
        </td>
      </tr>
    </table>

    <search-paging [loading]="loading" [searchComponent]="this"></search-paging>
  </div>
</div>

<div class="modal-body" *ngIf="showSelectedResults">
  <h6>
    <button class="mb-1 btn" (click)="hideSelected()">&lt;</button>
    Références sélectionnées
  </h6>

  <table class="table table-sm mt-3" *ngIf="results">
    <tr *ngFor="let reference of selectedResults.values()">
      <td>
        <reference-image [reference]="reference"></reference-image>
      </td>
      <td>{{ reference.isbn }}</td>
      <td>{{ reference.title }}</td>
      <td>{{ reference.authors }}</td>
      <td>
        <span *ngIf="reference.supplierReferences.length > 0">{{ reference.supplierReferences[0].retailPrice / 100 | number:'1.2-2' }} $</span>
      </td>
      <td>
        <button class="btn btn-sm btn-light" (click)="toggleSelected(reference.isbn, reference)"><span class="bi bi-trash"></span></button>
      </td>
      <td>
        <a class="ml-2" [routerLink]="['/inventory/reference', reference.isbn]" target="_blank"><i class="bi bi-card-heading"></i></a>
      </td>
    </tr>
  </table>
</div>

<div class="modal-footer d-flex">
  <span class="mr-auto" *ngIf="!showSelectedResults">
    <button class="btn btn-link" *ngIf="selectedCount() != 0" (click)="showSelected()">{{ selectedCount() }} référence(s) sélectionnée(s)</button>
    <span *ngIf="selectedCount() == 0">Aucune référérence sélectionnée</span>
  </span>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Annuler</button>
  <button type="button" class="btn" [disabled]="selectedCount() == 0" [class.btn-success]="selectedCount() != 0" (click)="addReferences()">Ajouter</button>
</div>